import { Spin } from 'antd';
import classnames from 'classnames';
import { sendAnalyticsEvent } from 'src/lib/googleAnalytics';
import { t } from 'src/lib/player/i18n';
import { GeolocationStatus, useStore } from 'src/lib/player/store';
import { onClickGenerator } from 'src/lib/player/utils/onClickGenerator';
import { IconLocation } from '../../BasicComponents/Icons';

export default function OwnLocationControl() {
  const setGeolocationStatus = useStore((state) => state.actions.setGeolocationStatus);
  const geolocationStatus = useStore((state) => state.timer.geolocation.status);

  function handleClick() {
    sendAnalyticsEvent('location-click');
    if (geolocationStatus === GeolocationStatus.OFF) {
      setGeolocationStatus(GeolocationStatus.SEARCHING);
    } else {
      setGeolocationStatus(GeolocationStatus.OFF);
    }
  }
  if (geolocationStatus === 'DISABLED') return null;

  return (
    <div
      className={classnames('mapboxgl-ctrl-group own-location-ctrl', {
        following: geolocationStatus === GeolocationStatus.FOLLOWING,
      })}
    >
      <button
        className="mapboxgl-ctrl-icon"
        title={t('Show own position')}
        {...onClickGenerator(handleClick)}
      >
        {geolocationStatus === GeolocationStatus.SEARCHING ? (
          <Spin size="small" />
        ) : (
          <IconLocation />
        )}
      </button>
    </div>
  );
}
